import {connect} from '../../app/connect';
import IssuesPanel from './IssuesPanel';
import {changeLocationAction, fetchIssuesAction, trackEvent, createReportAction} from '../../app/actions';
import {
  getCurrentDocument,
  getFetchParams,
  getIssuesCollectionLoading,
  getIssuesCollectionError,
  getSortedIssuesFilteredBySheetsInDocument,
  getPushpinWorkflowEnabled,
  canCreateIssue,
  isProjectSetupInProgress,
  getCurrentViewType,
  isCreatingReport
} from '../../app/selectors';
import featureFlags, {FEATURE_FLAGS} from '../../utils/featureFlags';

const mapStateToProps = state => ({
  fetchParams: getFetchParams(state),
  document: getCurrentDocument(state),
  loading: getIssuesCollectionLoading(state),
  error: getIssuesCollectionError(state),
  issues: getSortedIssuesFilteredBySheetsInDocument(state),
  pushpinWorkflowEnabled: getPushpinWorkflowEnabled(state),
  canCreateIssue: canCreateIssue(state),
  viewType: getCurrentViewType(state),
  isCreatingReport: isCreatingReport(state),
  shouldShowProjectSetupInProgressPlaceholder:
    featureFlags.get(FEATURE_FLAGS.PROJECT_SETUP_IN_PROGRESS_EMPTY_STATE) && isProjectSetupInProgress(state)
});

export default connect(
  mapStateToProps,
  {
    changeLocationAction,
    fetchIssuesAction,
    trackEvent,
    createReportAction
  }
)(IssuesPanel);
